import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H3 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ErrorBoundary from '../../components/ErrorBoundary';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function linkOverride(handleClick) {
  return props => /*#__PURE__*/_jsx("span", {
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
      children: props.children
    }))
  });
}
export function ModalErrorBoundary({
  actions,
  children
}) {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    identifier: "action-modal-error-boundary",
    fallback: /*#__PURE__*/_jsxs(UIModal, {
      use: "conversational",
      size: "auto",
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "errorStates.loading.title"
          })
        })
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(UIErrorMessage, {
          illustration: "errors/general",
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "errorStates.loading.message_jsx",
              elements: {
                Link: linkOverride(() => {
                  window.location.reload();
                })
              }
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        align: "center",
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: actions.close,
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "common.cancel"
          })
        })
      })]
    }),
    children: children
  });
}